<template>
  <div>
    <v-container>
      <div class="breadcrumbs-wrap">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <h1 class="title-pg">{{ oopt.transName }} - {{ $t('НПА') }}</h1>
      <div class="workroom-pg">
        <div class="bgw-pdg-20 my-organization">
          <div class="add-npa-row">
            <NpaAdd :ooptId="oopt.id" @updateNpaList="updateNpaList($event)">
              &nbsp;{{ $t('Добавить НПА') }}
            </NpaAdd>
          </div>
          <div class="table-overflow">
            <table class="table-full fix-title">
              <thead>
              <tr>
                <td>№</td>
                <td>{{ $t('Наименование') }}</td>
                <td>{{ $t('Ссылка') }}</td>
                <td>{{ $t('Привязан к ООПТ') }}</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(npa, i) in oopt.npas" :key="npa.id">
                <td>{{ ++i }}</td>
                <td class="title-td">
                    <NpaAdd
                      :ooptId="oopt.id"
                      :npaId="npa.id"
                      :npaEdit="true"
                      @updateNpaList="updateNpaList($event)"
                    >
                      {{ npa.transName }} № {{ npa.npa_number }} {{ $t('от')}} {{ new Date(npa.adoption_date) | dateFormat('DD.MM.YYYY')}} <span class="edit-icon"></span>
                    </NpaAdd>
                </td>
                <td>
                  <a :href="npa.link" target="_blank">{{ npa.link }}</a>
                </td>
                <td>{{ npa.oopt ? $t('да') : $t('нет') }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import NPA from '@/model/npa'
import NpaAdd from '@/components/oopt/NpaAdd'

export default {
  components: { NpaAdd },
  data: () => ({
    oopt: {},
    breadcrumbs: []
  }),
  watch: {
    $route: 'fetchData',
    page () {
      this.fetchData()
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      NPA.list(this.$route.params.id)
        .then((response) => {
          this.oopt = { ...response.data.oopt }
          this.breadcrumbs = [
            { text: this.$i18n.t('Главная'), disabled: false, href: '/' },
            { text: this.$i18n.t('Рабочий кабинет'), disabled: false, href: '/my-organization' },
            { text: this.oopt.transName, disabled: false, href: '/my-organization?id=' + this.oopt.id },
            { text: this.$i18n.t('НПА'), disabled: true }
          ]

          this.setLoading(false)
        })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
          this.setLoading(false)
        })
    },
    // Обновление списка НПА
    updateNpaList () {
      this.fetchData()
    }
  }
}
</script>
